// should be same as sheet-event.enum
export const SHEET_EVENTS = {
  delete: 'delete',
  publish: 'publish',
  reconcile: 'reconcile',
  submit: 'submit',
  update: 'update',
  updateSeveral: 'updateSeveral',
};
